import {game} from "js/main";

export function isBomb(bubbleType: number) {
  return game.config.bubbleNames[bubbleType] === 'bomb';
}
